import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Box, Hidden, Paper, Typography, Grid} from '@mui/material';
import Logo from '../images/QSI-Logo.png';
import background from '../images/Login-Background.jpg';
import LoadingButton from "@mui/lab/LoadingButton";
import Button from "@mui/material/Button";

export function BaseInputPage({children, pageTitle, titleInfo, isSuccessful = false, successMsg, linkText, linkHref}) {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    return (
        <>
            <title>{pageTitle}</title>
            <div
                style={{
                    backgroundImage: `url(${background})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center center',
                    height: '100vh',
                    width: '100vw'
                }}
            >
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    style={{height: '100vh'}}
                >
                    <Box
                        component={Paper}
                        elevation={6}
                        square
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        padding={0}
                        height={500}
                    >
                        <Hidden lgDown>
                            <img
                                src={Logo}
                                alt="QSI Logo"
                                style={{
                                    height: '100%',
                                    width: 'auto'
                                }}
                            />
                        </Hidden>
                        <Grid
                            container
                            direction="column"
                            sx={{
                                alignItems: "center",
                                justifyContent: {xs: "flex-start", lg: "center"},
                                height: "100%",
                                maxWidth: "500px",
                                padding: 2,
                            }}
                        >
                            <Hidden lgUp>
                                <Grid
                                    item
                                    sx={{
                                        height: "25%",
                                    }}
                                >
                                    <img
                                        src={Logo}
                                        alt="QSI Logo"
                                        style={{width: '100px', marginBottom: 0}}
                                    />
                                </Grid>
                            </Hidden>
                            {!isSuccessful ? (
                                <>
                                    <Grid
                                        item
                                        sx={{
                                            height: "20%"
                                        }}
                                    >
                                        <Box>
                                            <Typography
                                                component="h3"
                                                sx={{
                                                    height: "100%",
                                                    textAlign: "center",
                                                    typography: {
                                                        xs: "h5",
                                                        sm: "h4"
                                                    }
                                                }}
                                            >
                                                Deposit Review Platform
                                            </Typography>
                                            <Typography
                                                component="h1"
                                                variant="h6"
                                                textAlign="center"
                                            >
                                                {titleInfo}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid
                                        item
                                        sx={{
                                            height: "50%",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            width: "100%"
                                        }}
                                    >
                                        {/*Dynamically loaded content from children page*/}
                                        {children}
                                    </Grid>
                                </>
                            ) : (
                                <>
                                    <Grid
                                        item
                                        sx={{
                                            display: "flex",
                                            height: linkText ? "20%" : "60%",
                                            alignItems: linkText ? "flex-start" : "center",
                                        }}
                                    >
                                        <Typography
                                            component="h1"
                                            sx={{
                                                textAlign: "center",
                                                typography: {
                                                    xs: "h5",
                                                    sm: "h4"
                                                }
                                            }}
                                        >
                                            {successMsg}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        sx={{
                                            height: linkText ? "50%" : "0%",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            width: "100%"
                                        }}
                                    >
                                        {linkText && (
                                            <LoadingButton
                                                fullWidth
                                                disabled={linkHref === null}
                                                loading={loading}
                                                href={linkHref}
                                                variant="contained"
                                                onClick={() => {
                                                    setLoading(true);
                                                }}
                                                sx={{
                                                    textTransform: 'none',
                                                    textAlign: "center"
                                                }}>
                                                {linkText}
                                            </LoadingButton>
                                        )}
                                        {pageTitle === "Reset Password" && (
                                            <Button
                                                fullWidth
                                                sx={{
                                                    textAlign: "center",
                                                    mt: 1
                                                }}
                                                onClick={() => navigate("/login")}
                                            >
                                                Back to Login
                                            </Button>
                                        )}
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Box>
                </Box>
            </div>
        </>
    );
}